// Project Imports
import DashboardResource from 'core/resources/Dashboard';
import CommunicationResource from 'core/resources/CommunicationHub';
import AudienceGrouping from 'core/resources/AudienceGrouping';
import NudgeConfigurationResource from 'core/resources/NudgeConfigurationResource';

const resources = [
  DashboardResource,
  CommunicationResource,
  AudienceGrouping,
  NudgeConfigurationResource,
];

export default resources;
